if (!window.customElements.get('bd-klaviyo-form')) {
  class BdKlaviyoForm extends HTMLElement {
    connectedCallback() {
      this.addEventListener('submit', this.onSubmit.bind(this));
    }

    async onSubmit(event) {
      event.preventDefault();

      const form = event.target;
      const companyId = this.getAttribute('data-public-key');
      const listId = this.getAttribute('data-list-id');
      const emailInput = form.querySelector('input[type="email"]');
      const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');

      if (!companyId || !listId) {
        console.error('bd-klaviyo-form: missing data-public-key or data-list-id');
        return;
      }

      if (!emailInput || !emailInput.reportValidity()) return;

      if (submitButton) submitButton.disabled = true;

      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
            revision: '2026-07-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: emailInput.value,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED'
                          }
                        }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId
                  }
                }
              }
            }
          })
        });

        if (response.ok) {
          this.showMessage(form, this.getAttribute('data-success-message'), 'success');
          form.reset();
          this.dispatchEvent(new CustomEvent('subscribed', { bubbles: true }));
        } else {
          this.showMessage(form, this.getAttribute('data-error-message'), 'error');
        }
      } catch (error) {
        this.showMessage(form, this.getAttribute('data-error-message'), 'error');
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    }

    showMessage(form, message, status) {
      if (!message) return;

      let banner = form.querySelector('.bd-klaviyo-form__banner');

      if (!banner) {
        banner = document.createElement('div');
        banner.className = 'bd-klaviyo-form__banner banner';
        banner.innerHTML = '<div class="banner__content"></div>';
        form.prepend(banner);
      }

      banner.classList.remove('banner--success', 'banner--error');
      banner.classList.add(`banner--${status}`);
      banner.querySelector('.banner__content').textContent = message;
    }
  }

  window.customElements.define('bd-klaviyo-form', BdKlaviyoForm);
}
